<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top">
      <div class="container">
        <div>
          <a class="" href="/">
            <img
              class="img-fluid d-block"
              src="/img/logo.png"
              style="width: 10%"
            />
          </a>
        </div>
        <div class="collapse navbar-collapse" id="navbar5">
          <ul class="navbar-nav ml-auto text-center" v-if="isLoggedIn">
            <router-link
              v-for="link in authlinks"
              :key="link.text"
              :to="link.route"
              class="nav-item"
            >
              <a class="nav-link">{{ link.text }}</a></router-link
            >
            <li role="presentation" class="dropdown">
              <a
                class="dropdown-toggle nav-link"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                style="font-size: 14px"
              >
                Cadastro <i class="fa fa-user fa-fw"></i>
              </a>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <router-link to="/dashboard/cadastro" class="nav-item">
                    <a class="btn btn-link mx-auto"
                      >Meu Cadastro</a
                    ></router-link
                  >
                </li>
                <li class="nav-item" @click="this.ActionDoLogout">
                  <a
                    class="btn btn-link mx-auto"
                    style="margin-left: 15px; cursor: pointer"
                    >Sair</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div id="inside">
      <router-view></router-view>
    </div>

    <div class="footer1" style="">
      <div class="container">
        <div class="row align-items-center pt-4">
          <div class="row col justify-content-around">
            <div>
              <h5><b>Tricard</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinksc"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tricard')"
                  ><li>
                    <a target="_blank" style="color: #1641cc">
                      {{ link.text }}
                    </a>
                  </li></router-link
                >
              </ul>
            </div>
            <div>
              <h5><b>Tribanco</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinks"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tribanco')"
                  ><li>
                    <i>
                      <a target="_blank" style="color: #1641cc"
                        >{{ link.text }}
                      </a>
                    </i>
                  </li></router-link
                >
              </ul>
            </div>
          </div>
          <div class="row col justify-content-center">
            <div>
              <p class="mb-0">Tricard | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="tel:+5508007223099"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 722 3099</a
              ><a
                @click="openWhats((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=551130033099"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(11)
                3003-3099</a
              >
              <hr />
            </div>
            <div>
              <p class="mb-0">Tribanco | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="tel:+5508009793355"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 979 3355</a
              ><a
                @click="openWhats((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=553430033366"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(34)
                3003-3366</a
              >
              <hr />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="mb-1">@tribanco | tricard</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="nav">
      <a class="nav-link wts bg-success" @click="openWhats()" target="_blank" style="cursor:pointer">
        <i class="fa fa-2x fa-whatsapp text-light"></i>
      </a>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Home",
  components: {},
  data: () => ({
    authlinks: [{ icon: "", text: "Início", route: "/dashboard" }],
    hrefwhatsapp: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
    footerlinks: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tribanco",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    footerlinksc: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tricard",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    largura: null,
    ipUser: null,
  }),
  methods: {
    ...mapActions("auth", [
      "ActionDoLogout",
      "ActionMenuLinks",
      "ActionGetUser",
      "ActionGetWhatsText",
      "ActionSendAccessLogWithoutToken",
      "ActionLogContato",
      "ActionGetIPAddress",
    ]),
    // ...mapActions('meusBoletos', ['ActionSendAccessLogWithoutToken']),

    async saveLogcontatoPhone(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      this.ActionLogContato({
        DocNumber: null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "Telefone",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },

    async openWhats(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      if (this.user != null) {
        var whats = await this.ActionGetWhatsText({
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });
        this.hrefwhatsapp = this.hrefwhatsapp + "&text=" + whats[0];
      }

      this.ActionLogContato({
        DocNumber: null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "WhatsApp",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },

    redirectPolitica(link, banco) {
      if (link.route.includes("https://")) {
        window.open(link.route, "_blank").focus();
      } else {
        this.$router.push({
          name: link.route,
          query: { title: link.text, banco },
        });
      }
    },
  },
  async created() {
    this.largura = window.screen.width;
    if (this.user != null) {
      await this.ActionGetUser();
      this.user.Menus.forEach((menuId) => {
        switch (parseInt(menuId)) {
          case 2:
            this.authlinks.push({
              icon: "",
              text: "Contratos Negociáveis",
              route: "/dashboard/minhas-dividas",
            });
            break;
          case 1:
            // this.authlinks.push({ icon: '', text: 'Boletos Ativos', route: '/dashboard/meus-boletos' });
            break;
          case 3:
            this.authlinks.push({
              icon: "",
              text: "Acordos",
              route: "/dashboard/meus-acordos",
            });
            break;
        }
      });
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
